import React from "react";
import { Space } from "antd";
import {
  AxStatistics,
  AxIconWrapper,
  AxDivider,
  AxButton,
} from "@dynata/axiom3";

class Stats extends React.Component {
  render() {
    return (
      <div className="section" id="stats">
        <h3>Statistics</h3>
        <p>Display statistic number.</p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space direction="vertical">
          <Space size="large" direction="vertical">
            <pre>{`<AxStatistics title="Statistics Title" value={112893} />`}</pre>
            <div className="prop-header">
              <p className="props-title">Props</p>
              <p>
                For AntD props, visit{" "}
                <AxButton
                  size="small"
                  type="link"
                  target="_blank"
                  href="https://ant.design/components/statistic/#API"
                >
                  https://ant.design/components/statistic/#API
                </AxButton>
              </p>
            </div>
            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>decimalSeparator</td>
                  <td>The decimal separator</td>
                  <td>string</td>
                  <td>
                    <code>.</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>formatter</td>
                  <td>Customize value display logic</td>
                  <td>(value) =&gt; ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>groupSeparator</td>
                  <td>Group separator</td>
                  <td>string</td>
                  <td>
                    <code>,</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>loading</td>
                  <td>Loading status of Statistic</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td>4.8.0</td>
                </tr>
                <tr>
                  <td>precision</td>
                  <td>The precision of input value</td>
                  <td>number</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>prefix</td>
                  <td>The prefix node of value</td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>suffix</td>
                  <td>The suffix node of value</td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>title</td>
                  <td>Display title</td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>value</td>
                  <td>Display value</td>
                  <td>string | number</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>valueStyle</td>
                  <td>Set value section style</td>
                  <td>CSSProperties</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>...others</td>
                  <td>
                    All extra props are passed down to the{" "}
                    <>
                      <AxButton
                        size="small"
                        type="link"
                        target="_blank"
                        href="https://4x.ant.design/components/statistic/#API"
                      >
                        {`<Statistic />`}
                      </AxButton>
                    </>{" "}
                    component.
                  </td>
                  <td></td>
                  <td>-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <div className="prop-header">
              <p className="props-title">Statistic.Countdown</p>
            </div>
            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>format</td>
                  <td>
                    Format as <a href="http://momentjs.com/">moment</a>
                  </td>
                  <td>string</td>
                  <td>
                    <code>HH:mm:ss</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>prefix</td>
                  <td>The prefix node of value</td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>suffix</td>
                  <td>The suffix node of value</td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>title</td>
                  <td>Display title</td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>value</td>
                  <td>Set target countdown time</td>
                  <td>number | moment</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>valueStyle</td>
                  <td>Set value section style</td>
                  <td>CSSProperties</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onFinish</td>
                  <td>Trigger when time's up</td>
                  <td>() =&gt; void</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onChange</td>
                  <td>Trigger when time's changing</td>
                  <td>(value: number) =&gt; void</td>
                  <td>-</td>
                  <td>4.16.0</td>
                </tr>
              </tbody>
            </table>

            <pre>{`<AxStatistics title="Statistics Title" value={112893} />

<AxStatistics
  title="Statistics Title"
  value={112893}
  prefix={
    <AxIconWrapper type="regular" size="24" icon={"fa-arrow-up"} />
  }
/>
            `}</pre>
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          Default
        </AxDivider>

        <Space direction="vertical" size={24}>
          <AxStatistics title="Statistics Title" value={112893} />

          <AxStatistics
            title="Statistics Title"
            value={112893}
            prefix={
              <AxIconWrapper type="regular" size="24" icon={"fa-arrow-up"} />
            }
          />
        </Space>
      </div>
    );
  }
}
export default Stats;
